import styled from '@emotion/styled';

export const ZoomButton = styled.button`
  position: relative;
  width: 50px;
  height: 50px;
  border: 2px solid #dfe0e1;

  &:hover {
    background: #ebebec;
    span {
      opacity: 1;
    }
  }
  &:focus::before {
    position: absolute;
    top: 3px;
    left: 2px;
    width: 92%;
    height: 90%;
    border: 1px dotted #c9cbcd;
    border-radius: 50% 0px 0 50%;
    content: '';
  }

  & span {
    position: absolute;
    bottom: -20px;
    left: -7px;
    color: #7f8287;
    font-size: 12px;
    white-space: nowrap;
    opacity: 0;
    transition: opacity 0.15s ease-in-out;
  }
  & svg {
    position: absolute;
    top: 13px;
  }
`;

export const ZoomOutButton = styled(ZoomButton)`
  border-radius: 50% 0px 0 50%;
  & svg {
    left: 17px;
  }
  &:focus::before {
    top: 3px;
    left: 2px;
    border-radius: 50% 0px 0 50%;
  }
`;

export const ZoomInButton = styled(ZoomButton)`
  border-left: none;
  border-radius: 0 50% 50% 0;
  & svg {
    left: 13px;
  }
  &:focus::before {
    top: 3px;
    left: 2px;
    border-radius: 0 50% 50% 0;
  }
`;
